import type { ParsedBusiness } from "~/data/.server/business";

export function InspectionsSection(props: {
  business: ParsedBusiness;
}) {
  const { carrierInfo } = props.business;

  const {
    driverInsp,
    vehicleInsp,
    hazmatInsp,
    driverOosRate,
    driverOosRateNationalAverage,
    vehicleOosRate,
    vehicleOosRateNationalAverage,
    hazmatOosRate,
    hazmatOosRateNationalAverage,
    crashTotal,
    fatalCrash,
    injCrash,
    towawayCrash,
    issScore,
  } = carrierInfo?.detail ?? {};

  return (
    <div className="grid-rows-flow grid grid-cols-2">
      <div>
        {/* Inspections */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">Inspections</h3>
          <p>
            <span className="font-semibold">Driver Inspections:</span>{" "}
            {driverInsp || 0}
          </p>
          <p>
            <span className="font-semibold">Vehicle Inspections:</span>{" "}
            {vehicleInsp || 0}
          </p>
          <p>
            <span className="font-semibold">Hazmat Inspections:</span>{" "}
            {hazmatInsp || 0}
          </p>
        </div>

        {/* Out-of-Service Rates */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">Out-of-Service Rates</h3>
          <p>
            <span className="font-semibold">Driver OOS Rate:</span>{" "}
            {driverOosRate || 0}%
            {driverOosRateNationalAverage && (
              <span> (National Average: {driverOosRateNationalAverage}%)</span>
            )}
          </p>
          <p>
            <span className="font-semibold">Vehicle OOS Rate:</span>{" "}
            {vehicleOosRate || 0}%
            {vehicleOosRateNationalAverage && (
              <span> (National Average: {vehicleOosRateNationalAverage}%)</span>
            )}
          </p>
          <p>
            <span className="font-semibold">Hazmat OOS Rate:</span>{" "}
            {hazmatOosRate || 0}%
            {hazmatOosRateNationalAverage && (
              <span> (National Average: {hazmatOosRateNationalAverage}%)</span>
            )}
          </p>
        </div>
      </div>
      <div>
        {/* Crash Data */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">Crash Data</h3>
          <p>
            <span className="font-semibold">Total Crashes:</span>{" "}
            {crashTotal || 0}
          </p>
          <p>
            <span className="font-semibold">Fatal Crashes:</span>{" "}
            {fatalCrash || 0}
          </p>
          <p>
            <span className="font-semibold">Injury Crashes:</span>{" "}
            {injCrash || 0}
          </p>
          <p>
            <span className="font-semibold">Towaway Crashes:</span>{" "}
            {towawayCrash || 0}
          </p>
        </div>

        {/* ISS Score */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">ISS Score</h3>
          <p>
            <span className="font-semibold">ISS Score:</span>{" "}
            {!!issScore ? issScore : "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
}
